import React, { useEffect, useState } from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { FONT_ENUM } from '../../types/global/fonts.types';

interface PillSegmentedControlProps {
    options: string[];
    onChange: (selected: string) => void;
    initialValue?: string;
}

const PillSegmentedControl: React.FC<PillSegmentedControlProps> = ({ options, onChange, initialValue }) => {
    const [selected, setSelected] = useState<string | null>(initialValue ?? options[0]);

    const handleAlignmentChange = (event: React.MouseEvent<HTMLElement>, newSelected: string | null) => {
        if (newSelected !== null) {
            setSelected(newSelected);
            onChange(newSelected);
        }
    };

    useEffect(() => {
        if (initialValue) setSelected(initialValue);
    }, [initialValue]);

    return (
        <ToggleButtonGroup
            value={selected}
            exclusive
            onChange={handleAlignmentChange}
            sx={{
                display: 'flex',
                borderRadius: '50px',
                overflow: 'hidden',
                backgroundColor: '#f0f0f0',
                '& .MuiToggleButton-root': {
                    border: 0,
                    borderRadius: '50px',
                    textTransform: 'none',
                    fontWeight: 500,
                    padding: '8px 16px',
                    color: '#555',
                    '&.Mui-selected': {
                        backgroundColor: '#6200ea',
                        color: '#fff',
                    },
                    '&:hover': {
                        backgroundColor: '#ddd',
                    },
                },
            }}>
            {options.map(option => (
                <ToggleButton
                    key={option}
                    value={option}
                    sx={{ fontFamily: FONT_ENUM.MAIN_MEDIUM, textTransform: 'capitalize' }}>
                    {option}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};

export default PillSegmentedControl;
